import React from 'react';
import { withFormik } from 'formik';
import { defaultTo } from 'ramda';
import Select from 'react-select';

import { apiUpdateProfile } from '../../../../../api/user';
import { apiUpdateRegistration } from '../../../../../api/registration';
import { handleError, handleSuccess } from '../../../../../util/forms';
import { routes } from '../../../../../routes';

import Footer from '../../../../../components/Accordion/Footer';
import Checkbox from '../../../../../components/Forms/Checkbox';
import EditField from '../../../../../components/Forms/EditField';

const Preferences = ({
  areasOfExpertise,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  isValid,
  setFieldValue,
  status,
  setStep,
  step,
}) => {
  return (
    <form>
      <p>
        As an FFC® certified Financial Coach, you have the opportunity to add your information to our Find a Certified
        Professional directory. This search tool is available at{' '}
        <a href={routes.wordPress.findAProfessional} target="_blank">
          www.SageFinancialSolutions.org/find-an-afc
        </a>{' '}
        and allows clients to more easily connect to you and your services. If you are currently providing financial coaching services, please respond to the questions below:
      </p>
      <p>You can change any of these settings in your profile.</p>

      <Checkbox
        name="provideCounselingServices"
        label="I am interested in being contacted for your financial counseling, coaching, or education services."
        checked={values.provideCounselingServices}
        onBlur={handleBlur}
        onChange={handleChange}
      />

      <Checkbox
        name="offerVirtualCounseling"
        label="I offer virtual services."
        checked={values.offerVirtualCounseling}
        onBlur={handleBlur}
        onChange={handleChange}
      />

      <Checkbox
        name="offerLocalCounseling"
        label="I offer local services."
        checked={values.offerLocalCounseling}
        onBlur={handleBlur}
        onChange={handleChange}
      />

      <Checkbox
        name="offerGroupWorkshops"
        label="I offer group workshops."
        checked={values.offerGroupWorkshops}
        onBlur={handleBlur}
        onChange={handleChange}
      />

      <EditField
        as={Select}
        bare
        multi
        name="areasOfExpertise"
        label="Areas Of Expertise (select all that apply)"
        status={status}
        onChange={(value) =>
          setFieldValue(
            'areasOfExpertise',
            value.map((area) => area.value),
          )
        }
        options={areasOfExpertise.map((area) => ({ value: area.id, label: area.name }))}
        value={values.areasOfExpertise}
      />
      <Footer step={step} setStep={setStep} isValid={isValid} isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
    </form>
  );
};

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateProfile(payload)
      .then(({ data }) => props.updateUser(data))
      .then(() => apiUpdateRegistration(props.registration.id, { stepName: props.name }))
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ user }) => ({
    areasOfExpertise: defaultTo([], user.areasOfExpertise).map((area) => area.id),
    provideCounselingServices: defaultTo(false, user.provideCounselingServices),
    offerVirtualCounseling: defaultTo(false, user.offerVirtualCounseling),
    offerLocalCounseling: defaultTo(false, user.offerLocalCounseling),
    offerGroupWorkshops: defaultTo(false, user.offerGroupWorkshops),
  }),
  isInitialValid: true,
  validateOnChange: true,
})(Preferences);
